import { Image as RenderImage } from '@react-pdf/renderer';

const Image = ({ source, styles }) => {
	if (source) {
		return <RenderImage style={styles} source={source} />;
	} else {
		return <></>;
	}
};

export default Image;
